// Bootstrap-Toasts in #flash-messages (Container im Layout, layouts/shared/_flash_messages). Quellen: Rails-flash
// beim Laden der Seite und Server-Pushes über die Turbo-Stream-Action notify (init/stream_actions.js), dazu direkte
// Aufrufe aus Stimulus. Vorbild: oxocare lib/bs_toast.js.
//
// Der Text wird als textContent gesetzt, nie als HTML: Meldungen können Fremdtext enthalten (z.B. den
// BLE-Advertising-Namen eines Geräts in Fehlermeldungen).

// Erfolg und Info verschwinden nach DURATION_MS, Fehler und Warnungen bleiben, bis sie geschlossen werden.
const DURATION_MS = 4000
const STICKY_VARIANTS = ["danger", "warning"]

// Rails-flash-Keys und Broadcaster-Typen -> Bootstrap-Farbe.
const VARIANTS = {
  notice: "success",
  success: "success",
  info: "info",
  alert: "danger",
  error: "danger",
  danger: "danger",
  warning: "warning",
}

// Auf diesen Farben ist der Text weiss, das Schliessen-Kreuz muss es auch sein.
const LIGHT_TEXT_VARIANTS = ["success", "danger"]

export function showToast(message, { type = "success" } = {}) {
  const container = document.getElementById("flash-messages")
  if (!container || !message) return null

  const variant = VARIANTS[type] || "info"
  const sticky = STICKY_VARIANTS.includes(variant)

  const toast = document.createElement("div")
  toast.className = `toast align-items-center text-bg-${variant} border-0`
  toast.setAttribute("role", sticky ? "alert" : "status")
  toast.setAttribute("aria-live", sticky ? "assertive" : "polite")
  toast.setAttribute("aria-atomic", "true")
  toast.dataset.controller = "toast-handler"
  toast.dataset.toastHandlerAutohideValue = String(!sticky)
  toast.dataset.toastHandlerDurationValue = String(DURATION_MS)

  const row = document.createElement("div")
  row.className = "d-flex"

  const body = document.createElement("div")
  body.className = "toast-body"
  body.textContent = message

  const close = document.createElement("button")
  close.type = "button"
  close.className = `btn-close ${LIGHT_TEXT_VARIANTS.includes(variant) ? "btn-close-white" : ""} me-2 m-auto`
  close.dataset.bsDismiss = "toast"
  close.setAttribute("aria-label", container.dataset.closeLabel || "")

  row.append(body, close)
  toast.append(row)
  container.append(toast)

  return toast
}
